module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('can', {
    attrs: {
      "action": "view",
      "subject": "users"
    }
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Users")]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "create",
      "subject": "add-user"
    }
  }, [_c('div', {
    staticClass: "ibox-tools"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Add user",
      "placement": "left"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.manageUser(null)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("General user login and profile information for employees using the system.")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content user-list-content"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "input form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search users..."
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search\n            ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.results,
      "fit": true,
      "default-sort": {
        prop: 'display_name'
      },
      "empty-text": !_vm.results.length && _vm.users.length ? ("No users found matching " + _vm.keyword) : 'No users',
      "max-height": "400",
      "width": "100%",
      "row-key": "id",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "avatar",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "user-avatar",
          attrs: {
            "src": scope.row.avatar || scope.row.gravatar
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": 'client-link',
      "label": "Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "Edit",
            "placement": "right"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              return _vm.manageUser(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.display_name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "job_title",
      "label": "Job title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Email"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "fa fa-envelope"
        }), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.email))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "label": "Roles"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "client-status pull-right"
        }, [_c('el-tooltip', {
          attrs: {
            "content": "Company Admin",
            "placement": "top"
          }
        }, [(scope.row.is_admin) ? _c('span', {
          staticClass: "label label-info"
        }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "Organization Admin",
            "placement": "top"
          }
        }, [(scope.row.is_org_admin) ? _c('span', {
          staticClass: "label label-primary"
        }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "Inactive",
            "placement": "top"
          }
        }, [(!scope.row.user_is_active) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "Active",
            "placement": "top"
          }
        }, [(scope.row.user_is_active) ? _c('span', {
          staticClass: "label label-success"
        }, [_vm._v(" ")]) : _vm._e()])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.loggedInUser.is_admin) ? _c('el-dropdown', {
          attrs: {
            "trigger": "hover",
            "placement": "bottom",
            "show-timeout": 100,
            "hide-on-click": false
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("\n                  Actions\n                  "), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.manageUser(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), (_vm.loggedInUser.id != scope.row.id && scope.row.user_is_active === true) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.deleteUser(scope.row)
            }
          }
        }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), (_vm.loggedInUser.id != scope.row.id && scope.row.user_is_active === true) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.showPasswordResetPopup(scope.row)
            }
          }
        }, [_vm._v("Change Password")]) : _vm._e()], 1)], 1) : _vm._e()]
      }
    }])
  })], 1)], 1)])]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "edit",
      "subject": "accounts-users"
    }
  }, [(_vm.showUserManage) ? _c('el-dialog', {
    attrs: {
      "title": _vm.selectedUser.id ? 'Edit User' : 'New User',
      "visible": _vm.showUserManage,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showUserManage = $event
      }
    }
  }, [(_vm.showUserManage) ? _c('user-manage', {
    attrs: {
      "user": _vm.selectedUser,
      "groups": _vm.groups,
      "loggedInUser": _vm.loggedInUser
    },
    on: {
      "cancelled": function($event) {
        _vm.showUserManage = false
      },
      "saved": _vm.handleSaved,
      "saveError": _vm.handleSaveError
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.restPasswordDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "Reset Password",
      "visible": _vm.restPasswordDialogVisible,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.restPasswordDialogVisible = $event
      }
    }
  }, [_c('PasswordOnlyResetFormOnUserList')], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-794f4dbb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/user/UserList.vue
// module id = 3350
// module chunks = 3